import { ObjectWithStringValuesI } from '../types/common';

export const ELEMENT_TYPE = {
  TABLE: 'TABLE',
  COLUMN: 'COLUMN',
  EDGE: 'EDGE',
  FOREIGN_EDGE: 'FOREIGN_EDGE',
};

export const DIAGRAM_COORDINATES = {
  TABLE_X: 100,
  TABLE_Y: 150,
  COLUMN_X: window.innerWidth - 450,
  COLUMN_Y: window.innerHeight - 150,
};

export const DATABASE_SOFTWARE_OPTIONS = [
  'POSTGRES',
  'ORACLE',
  'MYSQL',
  'SQLITE',
];

export const DIAGRAM_SOFTWARE_COLORS: ObjectWithStringValuesI = {
  POSTGRES: 'purple',
  MYSQL: 'green',
  ORACLE: 'red',
  SQLITE: 'cyan',
};

export const DIAGRAM_CATEGORIES = [
  'SCIENCE',
  'FINANCE',
  'HEALTH',
  'EDUCATION',
  'ENTERTAINMENT',
  'BUSINESS',
  'SOCIAL',
  'TECHNOLOGY',
  'OTHER',
];

export const DIAGRAM_CATEGORIES_COLORS: ObjectWithStringValuesI = {
  SCIENCE: 'cyan',
  FINANCE: 'yellow',
  HEALTH: 'green',
  EDUCATION: 'yellow',
  ENTERTAINMENT: 'purple',
  BUSINESS: 'purple',
  SOCIAL: 'red',
  TECHNOLOGY: 'cyan',
  OTHER: 'gray',
};

export const QUERY_TYPES: ObjectWithStringValuesI = {
  CREATE_TABLE: 'CREATE_TABLE',
  INSERT_INTO: 'INSERT_INTO',
  NLP_SELECT: 'NLP_SELECT',
};
